import clsx from 'clsx';
import React from 'react';
import { polymorphicFactory } from '../../factory/factory.utils.mjs';
import { Box } from '../../Other/Box/Box.mjs';
import { InlineStyles } from '../../Other/InlineStyles/InlineStyles.mjs';
import { parseStyleProps } from '../../utils/styleProps.mjs';
import { useRandomClassName } from '../../utils/hooks/hooks.mjs';
import classes from './Grid.module.css.mjs';
import { GRID_STYLE_PROPS_DATA } from './Grid.utils.mjs';

const Grid = polymorphicFactory(
  (props, ref) => {
    const { component = "div", className, children, rowGap, style, ...rest } = props;
    const responsiveClassName = useRandomClassName();
    const parsedStyleProps = parseStyleProps({
      styleProps: { rowGap },
      data: GRID_STYLE_PROPS_DATA
    });
    const classNames = clsx(classes.root, className, "kohler-grid-root", parsedStyleProps.hasResponsiveStyles && responsiveClassName);
    const parsedStyles = {
      ...style,
      ...!parsedStyleProps.hasResponsiveStyles ? parsedStyleProps.inlineStyles : {}
    };
    return /* @__PURE__ */ React.createElement(React.Fragment, null, parsedStyleProps.hasResponsiveStyles && /* @__PURE__ */ React.createElement(InlineStyles, { selector: `.${responsiveClassName}`, styles: parsedStyleProps.styles, media: parsedStyleProps.media }), /* @__PURE__ */ React.createElement(Box, { component, ref, className: classNames, style: parsedStyles, ...rest }, children));
  }
);

export { Grid };
